module.exports = function() {
  return new Worker(__webpack_public_path__ + "8669e4ce091478e72730.worker.js");
};